
import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { EventsApiService, EventUpdateDTO } from 'features/events';
import { queryClient } from 'providers';

import { eventsQueryKeys } from './query-keys';

const { eventUpdateStatus } = EventsApiService();

export const useEventDeleteStatus = () => {
    const { message } = App.useApp();

    return useMutation(
        (payload: EventUpdateDTO) => {
            return eventUpdateStatus(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                message.success("Deleted Successfully");
            },
        },
    );
};
